exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-trigger[data-v-20739e3e]{display:contents}", ""]);

// exports
